import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initializeDatadogRUM } from "@/services/monitoring";
import { initAuth } from "./services/auth/auth";

// Expose build-time env suffix so SystemConfigs.getExchangePageUrl() resolves the correct host
(globalThis as Record<string, unknown>)["ENVIRONMENT_SUFFIX"] =
  import.meta.env.VITE_ENVIRONMENT_SUFFIX;

// AuthClient/SystemConfigs read AUTH_SERVICE_URL off `globalThis`, not import.meta.env —
// bridge our existing Vite env var so AuthClient can find it.
(globalThis as unknown as Record<string, string>).AUTH_SERVICE_URL =
  import.meta.env.VITE_API_GATEWAY_URL;

// Initialize Datadog RUM as early as possible
initializeDatadogRUM();
initAuth();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
